export default __webpack_public_path__ + "static/media/calendarA.44ab8178.svg";